import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectCoverflow, Navigation, Pagination, Keyboard } from "swiper/modules"; // Add Keyboard module
import "./TrendingSlider.css";


const TrendingSlider = () => {
  const items = [
    { img: "/images/belts/01-white.jpg", name: "White Belt" },
    { img: "/images/belts/02-yellow.jpg", name: "Yellow Belt" },
    { img: "/images/belts/03-green.jpg", name: "Green Belt" },
    { img: "/images/belts/04-orange.jpg", name: "Orange Belt" },
    { img: "/images/belts/05-blue.jpg", name: "Blue Belt" },
    { img: "/images/belts/06-purple.jpg", name: "Purple Belt" },
    { img: "/images/belts/07-brown.jpg", name: "Brown Belt" },
    { img: "/images/belts/08-black.jpg", name: "Black Belt" },
  ];

  return (
    <section id="trending">
      <div className="container">
        <Swiper
          modules={[EffectCoverflow, Pagination, Navigation, Keyboard]} // Add Keyboard module
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          loop={true}
          slidesPerView="auto"
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5,
          }}
          pagination={{ clickable: true }}
          navigation={true}
          keyboard={{
            enabled: true, // Enable keyboard navigation
            onlyInViewport: true, // Only works when slider is in viewport
          }}
        >
          {items.map((item, index) => (
            <SwiperSlide key={index} className="trending-slide">
              <div className="trending-slide-img">
                <img src={item.img} alt={item.name} />
              </div>
              <div className="belt-name-overlay">{item.name}</div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TrendingSlider;